import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import { setTimeout } from 'worker-timers';
import cookie from 'react-cookies';
import { getURLDomain, logoutFunction, redirectToLogin } from "../common/utils";
import SnackbarUtils from "../components/NotistackPlus";
import { RIMS_COOKIE_STG_CONSTANTS, RIMS_LOCAL_STG_CONSTANTS, RIMS_SESSION_STG_CONSTANTS, USERTENANTIDAPI } from "../constants";
import { useConfigStore } from "../store/config";
import { getSessionRemainTime } from "./login";
// import { toast } from 'react-toastify';

export const isLocal = process.env.NODE_ENV === 'development';


function getApiBaseUrls() {
  if (isLocal) {
    return {
      serviceUrf: process.env.REACT_APP_API_GETWAY,
      serviceQuicksight: process.env.REACT_APP_API_GETWAY_QUICKSIGHT
    };
  } else {
    const URLDomain = getURLDomain();
    return {
      serviceUrf: `https://api.${URLDomain}`,
      serviceQuicksight: `https://api.${URLDomain}/report`
    };
  }
}
const baseUrls: Record<string, any> = getApiBaseUrls();
export const basicUrl = baseUrls.serviceUrf;
export const quickSightBasicUrl = baseUrls.serviceQuicksight;
const refreshURL = '/common-auth/refresh';
const service = axios.create({
  baseURL: basicUrl,
});

service.interceptors.request.use(
  (config) => {
    const language = useConfigStore.getState()?.language;
    const languageformat = language === "en" ? "" : language;
    const token = cookie.load(RIMS_COOKIE_STG_CONSTANTS.LOGIN_TOKEN);
    // // @ts-ignore
    // if (!token && config.url?.indexOf(AUTH_PREFIX) === -1) {
    //   redirectToLogin();
    // }
    if (config.url?.includes?.('https://')) {
      config.baseURL = '';
    }
    token
      ? (config.headers = {
        "Content-Type": (config.responseType === 'arraybuffer' && JSON.stringify(config.data) === '{}') ? "application/octet-stream;charset=utf-8" : "application/json;charset=utf-8",
        Authorization: `Bearer ${token}`,
        "X-Tenant-Id": USERTENANTIDAPI.some((api) => config.url?.includes(api)) ? 
                        cookie.load(RIMS_COOKIE_STG_CONSTANTS.USER_TENANT_ID) : 
                        sessionStorage.getItem(RIMS_SESSION_STG_CONSTANTS.CURRENT_TENANT_ID) || cookie.load(RIMS_COOKIE_STG_CONSTANTS.AC_TENANT_ID) || cookie.load(RIMS_COOKIE_STG_CONSTANTS.USER_TENANT_ID),
        "Accept-Language": languageformat || ""
      })
      : (config.headers = {
        "Content-Type": "application/json;charset=utf-8",
        "Accept-Language": languageformat || ""
      });
    // : (config.headers = {
    //     "Content-Type": "application/json;charset=utf-8",
    //   });
    // config.data = QS.stringify(config.data)
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response: any) => {
    if (response.config.responseType !== 'arraybuffer') {
      if (response.status) {
        switch (response.status) {
          case 200:
          // 202 carries a normal payload too (the accepted form import job); without this case the
          // caller silently receives undefined.
          case 202:
            return response.data;
          case 400:
          case 401:
          case 403:
            if (response.config?.url?.indexOf(refreshURL) > -1) {
              logoutFunction();
              redirectToLogin();
            }
            return;
          default:
            console.log("error", response.data.msg);
        }
      }
    } else {
      return response;
    }
  },
  (err) => {
    if (err.config?.url?.indexOf(refreshURL) > -1) {
      logoutFunction();
      redirectToLogin();
      return;
    } else {
      switch (err.response.status) {
        case 401:
          logoutFunction();
          redirectToLogin();
          break;
        case 403:
          getSessionRemainTime().then((data: any) => {
            const timeRemain = Number(data.data);
            if (timeRemain > 0) {
            } else {
              SnackbarUtils.error('Your session has expired. Please refresh the page to log in again.');
              setTimeout(() => {
                logoutFunction();
                redirectToLogin();
              }, parseInt(cookie.load(RIMS_COOKIE_STG_CONSTANTS.REMIAN_TIME), 10) * 1000 || 2000)
            }
          }).catch((err: any) => {
            console.log('get session remain time error')
          })
          break;
        case 500:
          SnackbarUtils.error(
            "There is something wrong with server, please try again later"
          );
          break;
        default:
        // SnackbarUtils.error('There is something wrong with server, please try again later')
      }
    }
    return Promise.reject(err);
  }
);

const refreshAuthLogic = (failedRequest: any) => {
  const userInfoJson: any = window.localStorage.getItem(
    RIMS_LOCAL_STG_CONSTANTS.USER_INFO
  );
  const userInfo: any =
    typeof userInfoJson === "string" ? JSON.parse(userInfoJson) : null;
  return service
    .post(refreshURL, {
      username: userInfo?.username,
      refreshToken: userInfo?.refreshToken,
    })
    .then((response: any) => {
      if (!response) {
        logoutFunction();
        redirectToLogin();
        return Promise.reject();
      } else {
        window.localStorage.setItem(
          RIMS_LOCAL_STG_CONSTANTS.LOGIN_TOKEN,
          response.data.accessToken
        );
        window.localStorage.setItem(
          RIMS_LOCAL_STG_CONSTANTS.USER_INFO,
          JSON.stringify(response.data)
        );
        failedRequest.response.config.headers["Authorization"] =
          "Bearer " + response.data.accessToken;
      }
      return Promise.resolve();
    })
    .catch((error: any) => {
      logoutFunction();
      redirectToLogin();
      return;
    });
};

createAuthRefreshInterceptor(service, refreshAuthLogic);

export const quickSightService = axios.create({
  baseURL: quickSightBasicUrl,
});

quickSightService.interceptors.request.use(
  (config) => {
    const token = cookie.load(RIMS_COOKIE_STG_CONSTANTS.LOGIN_TOKEN);
    token
      ? (config.headers = {
        "Content-Type":
          config.responseType === "arraybuffer" &&
            JSON.stringify(config.data) === "{}"
            ? "application/octet-stream;charset=utf-8"
            : "application/json;charset=utf-8",
        Authorization: `Bearer ${token}`,
      })
      : (config.headers = {
        "Content-Type": "application/json;charset=utf-8",
      });
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

quickSightService.interceptors.response.use(
  (response: any) => {
    if (response.config.responseType !== "arraybuffer") {
      if (response.status) {
        switch (response.status) {
          case 200:
            return response.data;
          case 400:
          case 401:
          case 403:
            if (response.config?.url?.indexOf(refreshURL) > -1) {
              logoutFunction();
              redirectToLogin();
              console.log(
                "I catch err refreshURL 401/400/403 in request. will return"
              );
            }
            return;
          default:
            console.log("error", response.data.msg);
        }
      }
    } else {
      return response;
    }
  },
  (err) => {
    if (err.config?.url?.indexOf(refreshURL) > -1) {
      logoutFunction();
      console.log("I catch err refreshURL 401. will return");
      redirectToLogin();
      return;
    } else {
      switch (err.response.status) {
        case 401:
          logoutFunction();
          redirectToLogin();
          console.log("I catch err 401. will return");
          break;
        case 403:
          getSessionRemainTime().then((data: any) => {
            const timeRemain = Number(data.data);
            if (timeRemain > 0) {
            } else {
              SnackbarUtils.error('Your session has expired. Please refresh the page to log in again.');
            }
          }).catch((err: any) => {
            console.log('get session remain time error')
          })
          break;
        case 500:
          if (localStorage.getItem(RIMS_LOCAL_STG_CONSTANTS.LOGIN_TOKEN)) {
            SnackbarUtils.error(
              "There is something wrong with server, please try again later"
            );
          }
          break;
        default:
        // SnackbarUtils.error('There is something wrong with server, please try again later')
      }
    }
    return Promise.reject(err);
  }
);

export default service;
